import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const TableWrapper = styled('div')`
  ${media.mdUp`
    min-height: 470px;
  `}
  min-height: 440px;
`;
